import { useShows } from "@/context/ShowContext";
import { fmtShowLabel } from "@/lib/formatters";

export function ShowSelector() {
  const { shows, selectedShowId, selectShow, isLoading } = useShows();
  if (isLoading) return null;
  if (shows.length === 0) return <span className="text-[#808297] text-xs">No shows</span>;

  return (
    <select
      value={selectedShowId ?? ""}
      onChange={(e) => selectShow(Number(e.target.value))}
      className="rounded-lg px-3 text-sm border-none focus:outline-none focus:ring-1 focus:ring-[#b87800]/40 max-w-[320px] sm:max-w-[420px] truncate"
      style={{
        height: "24px",
        lineHeight: "24px",
        background: "linear-gradient(15deg, #505166, #57586d)",
        color: "#818092",
      }}
    >
      {shows.map((s) => (
        <option key={s.id} value={s.id}>{fmtShowLabel(s.first_perf_date, s.event_title)}</option>
      ))}
    </select>
  );
}
